// extracted by mini-css-extract-plugin
export default {"button":"Lk-z","reviewSort":"Mk-z"};